export default "__VITE_ASSET__976f07b6__"